import React, { useEffect, useState , useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetTheExitDelete,
  SetTheExitActions,
  SetTheNo_due_formdata,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  settheNodueFromState,
  setThaNodueFromrRegion,
  setThaNoDueFormZone,
  settheNodueFormStatusState,
  setTheNodueDesginations,
  setTablePositionPersist

} from "../../../Redux/Slice";
import Nodue from "./Nodue";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import ReactTable from "../../AppComponent/Table";
import ExitApproval from "./ExitApproval";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";

import BanImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-26.svg";
import useDebouncedEffect from 'use-debounced-effect';

const Exit = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
      const TablePositionPersist = useSelector(
      (state) => state.PreviousPagePosition.TablePositionPersist
    )
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setData] = useState([]);

const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.NodueformlistRequestedPagelist?.page == undefined
      ? 1
      : TablePositionPersist.NodueformlistRequestedPagelist.page
  );

const [search, setsearch] = useState(
    TablePositionPersist?.NodueformlistRequestedPagelist?.search == undefined ||
    TablePositionPersist?.NodueformlistRequestedPagelist?.search ==""
      ? ""
      : TablePositionPersist.NodueformlistRequestedPagelist.search
  ); 
   

  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [MakeCreate, setCreateBar] = useState(true);

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "0",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [filterForWhite, setFilters] = useState({ white_collar: 

    state.StateManagementOverallCall.NodueEmployeedesignation?.value == ""?
    "":
    state.StateManagementOverallCall.NodueEmployeedesignation?.value == 1 ?
    false:
    state.StateManagementOverallCall.NodueEmployeedesignation?.value == 0 && true

   });
    
  const HandleEMprole = (e) => {
    if (e != null) {
       dispatch(setTheNodueDesginations(e))
        console.log(e , "efwjeofp");
        
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else  if(e.value == 2){
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      }
      else  {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(setTheNodueDesginations({value:"",label:"All"}))

       }
    }
  };

  const FileterState = {
    status: state.StateManagementOverallCall.NodueFormStatusState?.value,
  };
  const UserObjectData = useSelector((state) => state.users.UserData);

  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
        state.StateManagementOverallCall.NodueformRegion

  );
  const [multiselect3, setMuliselect3] = useState(
        state.StateManagementOverallCall.NodueformZone

  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setDatas] = useState({ 
    zone: state.StateManagementOverallCall.NodueformZone?.value,     
    state:state.StateManagementOverallCall.NodueformState?.value, 
     region: state.StateManagementOverallCall.NodueformRegion?.value, 
    
    });
  const [multiselect, setMuliselect] = useState([
    state.StateManagementOverallCall.NodueformState
  ]);
  const options = [
    { value:"" , label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];

  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  const [sno, setsno] = useState(0);

  //--------Place---Holder----dispatch======
  useEffect(() => {
    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }

    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);


  useEffect(() => {
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      selectVal: selectVal,
      data: data,
      white_collar: filterForWhite.white_collar,
    };
    dispatch(SetTheExitActions(payload));
          dispatch(
              setTablePositionPersist({
                data: payload,
                pageName: "NodueformlistRequestedPagelist",
              })
            );
  }, [selectVal, data, filterForWhite, dtpageindex,search]);
  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setDatas({
        ...data,
        region: selectedVal.value,
      });
      dispatch(setThaNodueFromrRegion(selectedVal));
      dispatch(setThaNoDueFormZone({ value: "", label: "ALL" }));


    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });


      dispatch(setThaNodueFromrRegion({ value: "search", label: "Search"}));
      dispatch(setThaNoDueFormZone({ value: "", label: "ALL" }));
      setDatas({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      dispatch(setThaNoDueFormZone(selectedVal));

      setDatas({
        ...data,
        zone: selectedVal.value,
      });

    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setThaNoDueFormZone({ value: "", label: "ALL" }));


    }
  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
       dispatch(settheNodueFromState(selectedVal));
       dispatch(setThaNodueFromrRegion({ value: "", label: "ALL" }));
       dispatch(setThaNoDueFormZone({ value: "", label: "ALL" }));


      console.log(selectedVal, "asfad");
      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({value:"", label:"ALL"})
      setMuliselect1({ value:"", label:"ALL" });
      setMuliselect3({ value:"", label:"ALL" });
      dispatch(settheNodueFromState({ value: "", label: "ALL" }));
      dispatch(setThaNodueFromrRegion({ value: "", label: "ALL" }));
      dispatch(setThaNoDueFormZone({ value: "", label: "ALL" }));

      setDatas({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

     ///-----State----Input Changes
     const handleInputChange = (Val) => {
      setSearchDebounance({
          ...SearchDebounance,
          stateSearch: Val,
      });
  
  };
  
  ///---Region-----------------
  const handleInputRegion = (Val) => {
      setSearchDebounance({
          ...SearchDebounance,
          regionSearch: Val,
      });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
      setSearchDebounance({
          ...SearchDebounance,
          zoneSearch: Val,
      });
  };
  
  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });
        }
    },
    500,
    [SearchDebounance]
  );

  useEffect(() => {
    setData(state.ExitCall.ExitDatas);
  }, [state.ExitCall.ExitDatas]);
  //console.log(state.ExitCall.ExitDatas, "OnDutyDatas");


  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
           setsearch(e);
    setdtPageindex(1);
  
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {

    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);



  const handleNext = (next) => {
    console.log(next ,"woiquenext");
    
    setCurrentPage(next + 1);
    
  };

   const GotoEnteredPage =(gotopage)=>{
    setCurrentPage(gotopage)
   }

   const handlePrevious = (previous) => {
    if (previous != 0) {
      setCurrentPage(previous);
   
    }
  };



  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
 
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const HandleSubmits = () => {
    const payload = {
      DeleteID: DeleteID,
      currentPage: dtpageindex,
      data: data,
      selectVal: selectVal,
      white_collar: filterForWhite.white_collar,
    };
    dispatch(SetTheExitDelete(payload, setDeletePopup(false)));
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
           if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p>{lastFourDigits}</p>; 
           }
        },
      },
      
      {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    // {
    //   Header: "Client Name",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <span>
    //           {row.row.original.client_id.client_name != null &&
    //           row.row.original.client_id.client_name != "" ? (
    //             <span>{row.row.original.client_id.client_name}</span>
    //           ) : (
    //             <span>{"---"} </span>
    //           )}
    //         </span>
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              {row.row.original.status.toLowerCase() === "approved" ? (
                <button
                  className=" btn Status"
                  component="span"
                  style={{ cursor: "not-allowed" }}
                >
                <span className="OuterActionSpan">
              
                      <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                  <span 
                   className="ActionsList">
                    Approved
                    </span>
                    </span>
                </button>
              ) : (
                <>
                  {row.row.original.status.toLowerCase() === "decline" ? (
                    <button
                      className=" btn Status"
                      component="span"
                      style={{ cursor: "not-allowed" }}
                      onClick={(e) => {
                        if (
                          !row.row.original.status.toLowerCase() == "approved"
                        ) {
                          setEmployeePop(true);
                          setEmployeeIDs(row.row.original.id);
                        }
                      }}
                    >
                      <span className="OuterActionSpan">
                      <span  className="EditImages">
                          <img src={BanImage}/>
                         </span>
                      
                      <span className="ActionsList">
                                                {"Decline"}
                                                </span>

                      </span>
                    </button>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() === "pending" ? (
                        <button
                          className=" btn Status"
                          component="span"
                          onClick={(e) => {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }}
                        >
                          {" "}
                          <span className="OuterActionSpan">
                          <span  className="EditImages">
                          <img src={EditImages}/>
                         </span>
                                               <span className="ActionsList">

                            {"Approve"}
                            </span>
                          </span>
                        </button>
                      ) : null}
                    </>
                  )}
                </>
              )}

            </div>
          </>
        );
      },
    },
  ],
  [sno]
    );
    ////------No----Due----form-----
  const ViewFunctions = (datas) => {
    dispatch(SetTheNo_due_formdata(datas));
    dispatch(getSideBarfilesActions("No Due Form"));

    if (state.ClientBranchIDs.Exit_No_dueData.id == datas.id) {
      navigate("/nodue");

    }
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
       dispatch(settheNodueFormStatusState({value:"",label:"All"}))
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    //  console.log(SelectedValues, "selectedvaluess");
    setDisplay(SelectedValues);

    setSelected(sel);
    SetStates(true);
 dispatch(settheNodueFormStatusState(SelectedValues))
    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,

        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>No Due Form</h3>

          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
              value={multiselect1}

            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}

            />
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "relative",
                top: "95px",
                width: "92%",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ width: "314px" }}></div>
              <div
                class=" field-div"
                style={{
                  position: "relative",
                  top: "-11px",
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  zIndex: "1",
                  width: "351px",
                }}
              >
                <label
                  for="validationCustom02"
                  class="form-label"
                  style={{ fontSize: "15px" }}
                >
                  Employee Role
                </label>

                <Select
                  className="Selects"
                  styles={{ position: "relative", top: "60px" }}
                  onChange={(e) => {
                    HandleEMprole(e);
                  }}
                  value={EMpROleSelected}
                  options={EmpRoles}
                  placeholder="search"
                />
              </div>
            </div> */}

            <ReactTable
              data={state.ExitCall.ExitDatas}
              columns={columns}
              totalItems={state.ExitCall.Total_counts}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.ExitCall.Total_counts}
              MakeCreate={MakeCreate}
              ViewParts={(e) => {
                ViewFunctions(e);
              }}
              values={state.StateManagementOverallCall.NodueFormStatusState}
              options={options}
              Filter={Filter}
              count={count}
              ClearState={ClearState}
              placeHold={"All"}
              ApproveRequestFilter={true}

              ///--- emoloyee role based filters -
              EmployeeRoleTrue={true}
              EmployeeRoleOption={EmpRoles}
              EMpROleSelected={state.StateManagementOverallCall.NodueEmployeedesignation}
              HandleEMprole={HandleEMprole}
              setsno={setsno}
              sno={sno}
              id={"spe"}
                    searchVal={TablePositionPersist?.NodueformlistRequestedPagelist?.search == "" || TablePositionPersist?.NodueformlistRequestedPagelist?.search ==undefined? "":TablePositionPersist.NodueformlistRequestedPagelist.search}
              search_key={true}

            />
          </div>
        ) : null}
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <ExitApproval
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          data={data}
          white_collar={filterForWhite.white_collar}
          search={search}
        />
      ) : null}

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
        />
      ) : null}
    </>
  );
};

export default Exit;
